var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0404 24.4099C11.2323 24.4099 10.5858 23.8442 10.4242 23.0362C9.69696 18.4301 6.06061 14.7937 1.37375 14.0665C0.565666 13.9049 0 13.2584 0 12.4503C0 11.6422 0.565666 10.9958 1.37375 10.8341C5.97981 10.1069 9.61615 6.47052 10.3434 1.78365C10.505 0.975569 11.1515 0.409912 11.9596 0.409912C12.7677 0.409912 13.4141 0.975569 13.5757 1.78365C14.303 6.38971 17.9394 10.0261 22.6263 10.7533C23.4343 10.915 24 11.5614 24 12.3695C24 13.1776 23.4343 13.824 22.6263 13.9857C18.0202 14.7129 14.3838 18.3493 13.6566 23.0362C13.4949 23.8442 12.7677 24.4099 12.0404 24.4099ZM12.0404 2.10688C11.1515 7.44021 7.03031 11.5614 1.69697 12.4503C7.03031 13.3392 11.1515 17.4604 12.0404 22.7937C12.9293 17.4604 17.0505 13.3392 22.3838 12.4503C17.0505 11.5614 12.9293 7.44021 12.0404 2.10688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.4ffdcda37a37b7f15005b7d89f1aa29a.svg";
export { ForwardRef as ReactComponent };